import store from '../vuex'

import bus from '@utils/bus'
import {get} from '@utils/storage'

const needAuth = route => route.meta.auth !== false

// Check route API permission
/*
const hasPermission = permission => {
  return store.getters.permissions.some(item => {
    return item.name === permission
  })
}
*/

export default async (to, from, next) => {
  // Position the scroll on top
  window.scrollTo(0, 0)

  // Show global loader
  bus.$emit('show-loader')

  // Await 300 ms to continue with router
  setTimeout(async () => {
    // Check if route doesn't need auth
    if (!needAuth(to)) {
      return next()
    }

    // Get auth data from storage
    const token = await get('token')
    const user = await get('user')

    // If token doesn't exists, redirect to login page
    if (!token) {
      return next({name: 'login'})
    }

    // If token exists user is logged
    // Store login info in vuex to keep user logged
    const login = {token, user}
    await store.dispatch('login', login)
    return next()
  }, 300)
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js